import Auth from './auth';
import sigV4Client from './sigV4Client';
import config from '../config';
import AWS from 'aws-sdk';

export async function invoke({
                               path,
                               method = 'GET',
                               headers = {},
                               queryParams = {},
                               body,
                             }) {
  if (!await Auth.user()) {
    throw new Error('User is not logged in');
  }

  const signedRequest = sigV4Client.newClient({
    accessKey: AWS.config.credentials.accessKeyId,
    secretKey: AWS.config.credentials.secretAccessKey,
    sessionToken: AWS.config.credentials.sessionToken,
    region: config.apiGateway.REGION,
    endpoint: config.apiGateway.URL,
  }).signRequest({
    method,
    path,
    headers,
    queryParams,
    body,
  });

  body = body ? JSON.stringify(body) : body;
  headers = signedRequest.headers;

  const results = await fetch(signedRequest.url, {
    method,
    headers,
    body,
  });

  if (results.status !== 200) {
    throw new Error(await results.text());
  }

  return results.json();
}

export async function upload(file, prefix = '') {
  if (!await Auth.user()) {
    throw new Error('User is not logged in');
  }

  const s3 = new AWS.S3({
    params: {
      Bucket: config.s3.BUCKET,
    },
  });
  const filename = `${prefix}${AWS.config.credentials.identityId}-${Date.now()}-${file.name}`;

  let result = await s3.upload({
    Key: filename,
    Body: file,
    ContentType: file.type,
    ContentDisposition: `attachment; filename="${file.name}"`,
    ACL: "public-read"
  }).promise();
  result.Name = file.name;
  return result;
}


// WEBPACK FOOTER //
// ./src/lib/api.js